import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useApiCall from '../../../../../hooks/useApiCall';
import userService from '../../../../../services/userService';

interface UseHandleSubmitInterface {
  newPassword: string;
}

export default function useHandleSubmit({
  newPassword,
}: UseHandleSubmitInterface) {
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const { apiCall } = useApiCall();

  const handleSubmit = useCallback(async () => {
    await apiCall({
      apiToCall: userService.changePassword,
      reqBody: JSON.stringify({
        newPassword,
      }),
      onStartLoad: () => setIsLoading(true),
      onEndLoad: () => setIsLoading(false),
      actionAfterResponse: (apiResponse) => {
        if (!apiResponse.success) {
          toast.error('Não foi possível alterar a senha. Por favor, tente novamente');
          setIsLoading(false);
          return;
        }
        toast.success('Senha alterada com sucesso!');
        navigate('/');
      },
      catchMessage: 'Não foi possível alterar a senha. Por favor, tente novamente',
    });
  }, [apiCall, navigate, newPassword]);

  return { handleSubmit, isLoading };
}
